export default function cssHasPseudo() {
	// eslint-disable-next-line no-console
	console.log('"@csstools/css-has-pseudo-experimental" is no longer supported. Please use "css-has-pseudo" instead.');
}
